export default "__VITE_ASSET__BmCkyVY0__"